import { useEffect } from "react";
import { toast } from "sonner";
import { registerSW } from "virtual:pwa-register";

const UPDATE_TOAST_ID = "pwa-update-available";

// Module-scoped so StrictMode's double effect run can't register the SW twice.
let registered = false;

// Registers the service worker and, when a new build is deployed, surfaces a
// persistent "Reload" toast (registerType is "prompt", so nothing auto-reloads).
export function PwaUpdatePrompt() {
  useEffect(() => {
    if (registered) return;
    registered = true;

    const updateSW = registerSW({
      onNeedRefresh() {
        // Fixed id so a repeat signal replaces the toast instead of stacking.
        toast("A new version is available.", {
          id: UPDATE_TOAST_ID,
          duration: Infinity,
          action: {
            label: "Reload",
            onClick: () => void updateSW(true),
          },
        });
      },
    });
  }, []);

  return null;
}
